/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'

type SharedContainerStylesProps = {
  gap?: string
}

type SharedTextStylesProps = {
  color?: string
  fontSize?: string
  fontWeight?: string
  height?: string
}

export const sharedContainerStyles = styled.div<SharedContainerStylesProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ gap }) => gap || '8px'};
  border-radius: 0px;
  background: #fff;
`

export const StyledCarouselContainer = styled.div`
  width: 100%;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  background: var(--surface-gray-xx-light-ffffff, #fff);

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
`

export const StyledRecentlyViewedWidgetContainer = styled(
  sharedContainerStyles
)`
  display: inline-flex;
  padding: 16px 16px 24px 16px;

  ${(props) => props.theme.mediaQuery.up('tablet-landscape')} {
    display: flex;
    padding: 16px 0px 32px 0px;
    gap: 8px;
  }
`

export const StyledContainer = styled(sharedContainerStyles)`
  width: 1440px;
  padding: 0px 24px;
  justify-content: center;
  align-items: center;
`

export const StyledBox = styled(sharedContainerStyles)`
  width: 1367px;
  padding: 0px 12px;
`

export const StyledProductsContainer = styled(sharedContainerStyles)`
  flex-direction: row;

  ${(props) => props.theme.mediaQuery.up('tablet-landscape')} {
    padding-bottom: 0px;
    justify-content: flex-start;
    gap: 16px;
    align-self: stretch;
  }
`

export const sharedTextStyles = styled.span<SharedTextStylesProps>`
  color: ${({ color }) => color || '#282832'};
  font-family: 'Roboto';
  font-size: ${({ fontSize }) => fontSize || '20px'};
  font-weight: ${({ fontWeight }) => fontWeight || '500'};
  line-height: ${({ height }) => height || 'normal'};
`

export const StyledHeaderText = styled(sharedTextStyles)`
  ${(props) => props.theme.mediaQuery.up('tablet-landscape')} {
    color: #333;
    font-size: 24px;
    line-height: 36px;
  }
`

export const DesktopContainer = styled.div`
  max-width: 1248px;
  margin: 0 auto;
`
